module.exports = __webpack_public_path__ + "static/media/shadan.70fba9c8.png";